module.exports = "<p>\n  {{'ROUTE_NOT_FOUND.DESCRIPTION' | translate}}\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/route-not-found/route-not-found.component.html
// module id = FS9g
// module chunks = 0